import Button from 'components/_UI/Button'
import ImageUpload from 'components/_UI/ImageUpload'
import Text from 'components/_UI/Text'
import React, { useState } from 'react'
import styled from 'styled-components'
import { Column } from 'styled/alignment/Column'
import buttonText from 'texts/buttons/buttonText'
import breakpoints from 'theme/breakpoints'
import colors from 'theme/colors'
import validateInputFile  from 'helpers/validate-input-file';
import allowedFilesTypes from 'texts/messages/allowedFilesTypes';

export default function ImageProduct({
    onToggleImage,
    onDeleteFile,
    resetState,
    selectedProduct,
    product
}) {
    const [tryAgain, setTryAgain] = useState(false)
    const [error, setError] = useState()

    function toggleFile(files) {
        const file = files[0]
        const validationFile = validateInputFile(file);

        if (!validationFile.isValid) {
            setError(validationFile.message);
            return
        }

        onToggleImage(file);
    }
    
    return (
        <Container>
            <Text size='small' color={colors.occasionalPurple}> Imagem do produto </Text>

            <ImageUpload 
                onToggleFile={toggleFile} 
                onDeleteFile={() => onDeleteFile()}
                tryAgain={tryAgain} 
                isEdit={selectedProduct}
                product={product}
                resetState={resetState}
                cropAspect={1}
                cropTitle='Ajustar imagem do produto'
                cropDescription='Arraste para reposicionar e use o zoom. A imagem será exibida em formato quadrado.'
                refreshTryAgain={() => {
                    setTryAgain(!tryAgain)
                    setError(false)
                }} 
            />

            <ContainerInfo>
                <Text name='small' marginTop={'2px'}>Arquivos permitidos: {allowedFilesTypes?.images}.</Text>
                <Text name='small'>Tamanho máximo permitido: 2 MB</Text>
            </ContainerInfo>
       
            {
                error && (
                    <Column marginTop='10px' verticalCenter>
                        <Text color={colors.danger} name='small'>{error}</Text>
                        
                        <Button 
                            category='outline'
                            onClick={() =>  {
                                setTryAgain(true)
                                setError(false)
                            }}
                        > 
                            {buttonText.tryAgain}
                        </Button>
                    </Column>
                ) 
                    
            }
        </Container>
    )
}

const Container = styled(Column)`
    align-items: center;

    & > span {
        width: 100%;
        display: flex;
        justify-content: center;
        @media screen and (min-width: ${breakpoints.sm}){
            width: 90%
        }
    }
    & > span > div {
        width: 100%;
        border-radius: 8px;
        height: 100%;
        margin-top: 0px;
    }

    & > span > div > div > p {
        display: none;
    }
`

const ContainerInfo = styled(Column)`
    padding: 10px;
    align-items: center;
`